import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [quota, setQuota] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("autosaas_token");
    if (!token) {
      setUser(null);
      setQuota(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setQuota(data.quota);
    } catch {
      localStorage.removeItem("autosaas_token");
      setUser(null);
      setQuota(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("autosaas_token", data.token);
    await refresh();
    return data.user;
  };

  const register = async (name, email, password) => {
    const referralCode = localStorage.getItem("autosaas_ref") || undefined;
    const { data } = await api.post("/auth/register", { name, email, password, referral_code: referralCode, origin_url: window.location.origin });
    localStorage.setItem("autosaas_token", data.token);
    localStorage.removeItem("autosaas_ref");
    await refresh();
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("autosaas_token");
    setUser(null);
    setQuota(null);
  };

  return (
    <AuthContext.Provider value={{ user, quota, loading, login, register, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
